import { Component, signal, input, output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { TextFieldComponent } from '../../../fields/standard/text-field/text-field.component';
import { AppModule } from '../../../../modules/app.module';
import { ZorroModule } from '../../../../modules/zorro.module';
import { ThirdPartyModule } from '../../../../modules/third-party.module';
import { AngularModule } from '../../../../modules/angular.module';
import { PasswordFieldComponent } from '../../../fields/standard/password-field/password-field.component';
import { FormBoxComponent } from '../../../ui/forms/form-box/form-box.component';
import { FormLabelComponent } from '../../../ui/forms/form-label/form-label.component';
import { FormLinkComponent } from '../../../ui/forms/form-link/form-link.component';
import { FormSubmitButtonComponent } from '../../../ui/forms/form-submit-button/form-submit-button.component';
import { ClientService } from '../../../../services/client.service';
import { HomeState } from '@mira-avant/mtlibs';
import { CleverLoginButtonComponent } from '../../../ui/clever-login-button/clever-login-button.component';

@Component({
	selector: 'app-login-form',
	standalone: true,
	imports: [
		AppModule,
		ZorroModule,
		ThirdPartyModule,
		AngularModule,
		TextFieldComponent,
		PasswordFieldComponent,
		FormBoxComponent,
		FormLabelComponent,
		FormLinkComponent,
		FormSubmitButtonComponent,
		CleverLoginButtonComponent,
	],
	templateUrl: './login-form.component.html',
	styleUrl: './login-form.component.scss',
})
export class LoginFormComponent {
	public onSubmit = output<any>();
	public onSwitchState = output<HomeState>();
	public loading = input(false);

	public isSelfRosteringAllowed = signal(false);
	public isCleverSsoAllowed = signal(false);

	public form: FormGroup = this.fb.group({
		username: ['', TextFieldComponent.validators],
		password: ['', PasswordFieldComponent.validators],
	});

	constructor(
		private fb: FormBuilder,
		private clientService: ClientService
	) {
		this.clientService.isSelfRosteringAllowed$().then((isSelfRosteringAllowed: boolean) => {
			this.isSelfRosteringAllowed.set(isSelfRosteringAllowed);
		});

		this.clientService.isCleverSsoAllowed$().then((isCleverSsoAllowed: boolean) => {
			this.isCleverSsoAllowed.set(isCleverSsoAllowed);
		});
	}

	public onFormSubmit() {
		this.onSubmit.emit(this.form.value);
	}

	public onForgotPassword() {
		this.onSwitchState.emit(HomeState.FORGOT_PASSWORD);
	}

	public onCreateAccount() {
		this.onSwitchState.emit(HomeState.CREATE_ACCOUNT);
	}

	public redirectToClever() {
		const redirectUri: string = encodeURIComponent('http://localhost:3000/clever/callback');
		const clientId: string = encodeURIComponent('1759b137049cd7702506');

		const url: string = `https://clever.com/oauth/authorize?response_type=code&redirect_uri=${redirectUri}&client_id=${clientId}`;

		//tell window to go to this url
		window.location.assign(url);
	}
}